@if (!areDigitalProviders && !areNonDigitalProviders) {
  <ng-container *ngTemplateOutlet="nonDigitalContent"></ng-container>
  <nz-divider class="my-3"></nz-divider>
  <ng-container *ngTemplateOutlet="digitalContent"></ng-container>
} @else if (areDigitalProviders) {
  <ng-container *ngTemplateOutlet="digitalContent"></ng-container>
} @else if (areNonDigitalProviders) {
  <ng-container *ngTemplateOutlet="nonDigitalContent"></ng-container>
}

<ng-template #digitalContent>
  <div>
    <p class="modal-intro m-0">
      {{ 'page.training-qualifications.modal.content.digital' | translate }}
    </p>
    @for (
      qualificationTraining of digitalQualificationTrainingLists | slice: 0 : 5;
      track qualificationTraining
    ) {
      <p class="list-text m-0">
        {{ qualificationTraining }}
      </p>
    }
    @if (digitalQualificationTrainingLists.length > 5) {
      <p class="list-text m-0">
        {{
          'page.training-qualifications.modal.content.more'
            | translate: { count: digitalQualificationTrainingLists.length - 5 }
        }}
      </p>
    }
    <p class="disclaimer-text m-0 mt-3">
      {{ 'page.training-qualifications.modal.disclaimer.digital' | translate }}
    </p>
  </div>
</ng-template>

<ng-template #nonDigitalContent>
  <div>
    <p class="modal-intro m-0">
      {{ 'page.training-qualifications.modal.content.non-digital' | translate }}
    </p>
    @for (
      qualificationTraining of nonDigitalQualificationTrainingLists
        | slice: 0 : 5;
      track qualificationTraining
    ) {
      <p class="list-text m-0">
        {{ qualificationTraining }}
      </p>
    }
    @if (nonDigitalQualificationTrainingLists.length > 5) {
      <p class="list-text m-0">
        {{
          'page.training-qualifications.modal.content.more'
            | translate
              : { count: nonDigitalQualificationTrainingLists.length - 5 }
        }}
      </p>
    }
  </div>
</ng-template>
